import clsx from "clsx";

import { BugTicketStatus } from "../redux/reducers/bugTicketSlice";

export const BUG_TICKET_STATUS_LABELS: Record<BugTicketStatus, string> = {
  open: "Open",
  in_progress: "In Progress",
  resolved: "Resolved",
  closed: "Closed",
};

const STATUS_CLASSES: Record<BugTicketStatus, string> = {
  open: "bg-blue-50 text-blue-700 dark:bg-blue-950/40 dark:text-blue-300",
  in_progress: "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300",
  resolved: "bg-green-50 text-green-700 dark:bg-green-950/40 dark:text-green-300",
  closed: "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400",
};

type BugTicketStatusBadgeProps = {
  status: BugTicketStatus;
  className?: string;
};

export const BugTicketStatusBadge = ({ status, className }: BugTicketStatusBadgeProps) => (
  <span className={clsx("inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap", STATUS_CLASSES[status], className)}>
    {BUG_TICKET_STATUS_LABELS[status]}
  </span>
);
